import {useEffect, useState} from "react";
import { Route, Switch, withRouter} from "react-router-dom";
import React from "react";
import {Grid} from "react-flexbox-grid";
import JournalList from "./JournalList";
import {getJobJournalsByProjectId} from "../../../api";
import {spinnerOff, spinnerOn} from "../../../components/Spinner";
import NewJobJournal from "./NewJobJournal";

import "containers/startproj/JobJournal/job_journal.css";
export const FORM_MODE_VIEW = 0;
export const FORM_MODE_EDIT = 1;
export const FORM_MODE_NEW = 2;

function JobJournal({location, history, project, status, refreshJobJournals, setRefreshJobJournals}) {
    const [jobJournalList, setJobJournalList] = useState([]);
    const [refresh, setRefresh] = useState(true);
    const [formMode, setFormMode] = useState(FORM_MODE_VIEW);
    useEffect(() => {
        async function getData() {
            spinnerOn();
            const jobJournalList = await getJobJournalsByProjectId(project.id);
            setJobJournalList(jobJournalList);
            spinnerOff();
            setRefresh(false);
            setRefreshJobJournals(false);
        }
        if (refreshJobJournals || refresh) getData();
    }, [refresh, refreshJobJournals]);

    function handleRefreshCall() {
        setRefresh(true);
    }
    async function setViewFormDialog(projectId,status, row){
        spinnerOn();
        setFormMode(FORM_MODE_VIEW);
        //setSaveVisibleText(false);
        spinnerOff();
        history.push(`/${status}/${projectId}/journal/${row.id}`);
    }

    async function setEditFormDialog(projectId,status,row){
        spinnerOn();
        setFormMode(FORM_MODE_EDIT);
        //setSaveVisibleText(true);
        spinnerOff();
        history.push(`/${status}/${projectId}/journal/${row.id}`);
    }

    async function setNewFormDialog(projectId, status){
        setFormMode(FORM_MODE_NEW);
        history.push(`/${status}/${projectId}/journal/new`);
    }

    return (
        <Grid fluid> 
            <Switch location={location}>
                <Route
                    exact
                    key="list"
                    path={`/:status/:projectId/journal`}
                    component={() =>
                        <JournalList
                            project={project}
                            status={status}
                            jobJournalList={jobJournalList}
                            setViewFormDialog={setViewFormDialog}
                            setEditFormDialog={setEditFormDialog}
                            setNewFormDialog = {setNewFormDialog}
                            formMode={formMode}
                            history={history}
                            handleRefreshCall={handleRefreshCall}
                            refreshJobJournals={refreshJobJournals}
                            refresh={refresh}
                        />
                    }
                />
                <Route
                    exact
                    key="journal"
                    path={`/:status/:projectId/journal/:id`}
                    component={() =>
                        <NewJobJournal
                            project={project}
                            status={status}
                            formMode={formMode}
                            history={history}
                            handleRefreshCall={handleRefreshCall}
                        />
                    }
                />
            </Switch>
        </Grid>
    );

}

export default withRouter(JobJournal);
